export default "__VITE_ASSET__D20Ny9V3__"